import { THEME_VARIANTS, reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  effectiveDateHelp: reskinStyles(theme, {
    display: 'inline-flex',
    verticalAlign: 'middle',
    '& > span': { display: 'inline-flex', height: 'auto' }
  }),
  changed: {
    marginBottom: theme.sizes.footerHeight + 50
  },
  row: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 8)
  },
  label: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 7)
  },
  labelWithDivider: {
    borderTop: '1px solid rgba(247,243,239, .3)',
    ...reskinStyles(theme, { borderTop: `1px solid ${theme.colors.card_divider}` }),
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    marginBottom: theme.spacing(3)
  },
  card: {
    padding: theme.spacing(8, 0)
  },
  toggleRow: {
    minHeight: 40
  },
  button: {
    color: theme.colors.button__text_primary,
    fontWeight: 600,
    backgroundColor: theme.colors.button__background_secondary,
    fontSize: 16,
    width: 150,
    ...reskinStyles(theme, {
      ...theme.actionStyles.secondary,
      '&&.Mui-disabled': theme.actionStyles.secondary['&.Mui-disabled']
    })
  },
  secondaryButton: {
    fontSize: 16,
    ...reskinStyles(theme, { ...theme.actionStyles.secondary, padding: theme.spacing(0, 5) }),
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.action_text : theme.onCard.orange_on_dark,
    // Outranks the theme's !important disabled color for textSecondary buttons.
    '&&.Mui-disabled': {
      color: `${theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colors.action_text : theme.onCard.orange_on_dark} !important`
    }
  },
  agentCancellationNote: {
    marginTop: theme.spacing(2),
    fontSize: 14,
    textAlign: 'right'
  },
  holdPaymentWarning: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: theme.spacing(2)
  }
});

export default makeStyles(styles);
